// extracted by mini-css-extract-plugin
export var dataCell = "_le-2";
export var dataRow = "_le-0";
export var headerRow = "_le-1";